import { Actions } from './types'
import { ScreenInManager } from './ScreenInManager/ScreenInManager'
import screenIn from './screenIn'

export function initAnimations({
	model,
	manager,
	pageId,
}: {
	model: Actions
	manager: ScreenInManager
	pageId: string
}) {
	manager.setDefinitions(model)
	manager.init(pageId)

	return screenIn({ model, manager })
}
